// extracted by mini-css-extract-plugin
var _1 = "RequestProfileHeaderContent-moduleactions__VBT29";
var _2 = "RequestProfileHeaderContent-moduledescriptionContent__bnlnI";
var _3 = "RequestProfileHeaderContent-moduledescriptionRow__le4pw";
var _4 = "RequestProfileHeaderContent-moduledescriptionRowWithActions__SdeaN";
var _5 = "RequestProfileHeaderContent-moduledescriptionText__G_ui5";
var _6 = "RequestProfileHeaderContent-moduleloading__ZpKmg";
var _7 = "RequestProfileHeaderContent-modulemessage__SmzZV";
var _8 = "RequestProfileHeaderContent-modulereadMoreButton__u6BZT";
var _9 = "RequestProfileHeaderContent-modulesection__vZqaY";
var _a = "RequestProfileHeaderContent-modulesectionLabel__eL7Bu";
var _b = "RequestProfileHeaderContent-moduletranslate__oq9hQ";
export { _1 as "actions", _2 as "descriptionContent", _3 as "descriptionRow", _4 as "descriptionRowWithActions", _5 as "descriptionText", _6 as "loading", _7 as "message", _8 as "readMoreButton", _9 as "section", _a as "sectionLabel", _b as "translate" }
